import i18nData from '@/i18n/i18n-data'
import { createI18n } from 'vue-i18n';

export const i18n = createI18n({
    locale: 'vi', // Ngôn ngữ mặc định
    messages: i18nData
});
